define(["require", "exports", "jquery", "knockout", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, $, ko, tools, KendoUtils, UserContext) {
    "use strict";
    var CustomerInvoices = /** @class */ (function () {
        function CustomerInvoices(customerId, initGridCallback) {
            this.userCanViewCustomerInvoices = ko.observable(UserContext.hasAccess("Admin,CustomerInvoices.View,CustomerInvoices.Edit,CustomerInvoices.Delete"));
            this.userCanEditCustomerInvoices = ko.observable(UserContext.hasAccess("Admin,CustomerInvoices.Edit,CustomerInvoices.Delete"));
            this.userCanDeleteCustomerInvoices = ko.observable(UserContext.hasAccess("Admin,CustomerInvoices.Delete"));
            this.userCanExportCustomerInvoices = ko.observable(UserContext.hasAccess("Admin,CustomerInvoices.Export"));
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            this.expandedItemIDs = [];
            var self = this;
            self.customerId = customerId;
            self.isLookupDataLoaded = false;
            if (self.userCanViewCustomerInvoices()) {
                // Get lookup data:
                var getLookupData = tools.ajaxGet({
                    url: "/CustomerInvoices/GetInvoicesLookupData",
                    data: { customerId: self.customerId },
                    success: function (data) {
                        if (data.Success) {
                            self.lookupLists = data.Data.lookupLists;
                            self.customerInvoicesGridStructure = self.lookupLists.GridStructures.InvoicesStructure;
                        }
                    }
                });
                $.when(getLookupData).done(function () {
                    self.initExportDataSource();
                    self.isLookupDataLoaded = true;
                    if (self.isInitGridRequested) {
                        self.initGrid();
                    }
                    if (initGridCallback) {
                        initGridCallback(self);
                    }
                });
            }
        }
        CustomerInvoices.prototype.initGrid = function () {
            if (this.userCanViewCustomerInvoices()) {
                if (!this.isLookupDataLoaded) {
                    this.isInitGridRequested = true;
                }
                else {
                    this.initInvoices();
                }
            }
        };
        CustomerInvoices.prototype.initExportDataSource = function () {
            var self = this;
            self.customerInvoicesDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerInvoices/GetInvoicesList",
                        type: "POST",
                        data: function () {
                            return {
                                customerId: self.customerId
                            };
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.customerInvoicesGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerInvoicesDataSource = new kendo.data.DataSource(self.customerInvoicesDataSourceOptions);
        };
        CustomerInvoices.prototype.initInvoices = function () {
            var self = this;
            var gridId = "divCustomerInvoicesTable";
            var columns = self.customerInvoicesGridStructure.columns;
            self.invoicesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: self.customerInvoicesDataSourceOptions,
                gridOptions: {
                    //toolbar: kendo.template($("#plans-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    sortable: true,
                    reorderable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    scrollable: true,
                    height: 500,
                    detailInit: self.initInvoiceItems.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.containsObject(self.expandedItemIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.containsObject(self.expandedItemIDs, rowData.Id)) {
                            self.expandedItemIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedItemIDs.length; i++) {
                            if (self.expandedItemIDs[i] === rowData.Id)
                                self.expandedItemIDs.splice(i, 1);
                        }
                    }
                },
                enableExport: {
                    entityName: "Invoice",
                    title: "Invoices",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false,
                controller: self
            };
            self.invoicesTable.initGrid(gridOptions);
        };
        CustomerInvoices.prototype.initInvoiceItems = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.InvoiceItemsStructure;
            $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/CustomerInvoices/GetInvoiceItems",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.invoiceId = e.data.Id;
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (event) {
                }
            }).data("kendoGrid");
        };
        CustomerInvoices.prototype.containsObject = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        return CustomerInvoices;
    }());
    return CustomerInvoices;
});
//# sourceMappingURL=customerInvoices.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerInvoices.js
// module id = 184
// module chunks = 2